import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5bw8e8irqb: FaireBrandEntity = {
  token: "b_5bw8e8irqb",
  type: "brand",
  name: "Boulder Tea Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/eff68f7890fb439dc36394f2c56d3fdb943f5475dd56b0087a020cec9c4ba070.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7481f7407715abb93f4627746f5c45bb664418007a31692b1a5e3445fadae4ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eff68f7890fb439dc36394f2c56d3fdb943f5475dd56b0087a020cec9c4ba070.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7481f7407715abb93f4627746f5c45bb664418007a31692b1a5e3445fadae4ed.jpeg",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 22,
  isInsider: true,
  description:
    "Welcome to The Boulder Tea Company, supplier and online store of the Boulder Dushanbe Teahouse in beautiful Boulder, Colorado.  Nestled against the Rocky Mountains in the shadow of the Continental Divide, the Boulder Dushanbe Teahouse is one of Boulder's most visited attractions, and offers a large curated collection of premium, artisan teas, both loose leaf and in premium, bio-degradable sachets.  \n \nWe offer the highest quality teas of each harvest season. Our boutique teas are carefully sourced or meticulously created in small batches with excusive blends formulated by our Certified Herbalist.  In addition we use organically grown herbs and flowers from our own Colorado organic farm, Three Leaf Farm.  In addition to our specialty teas, we offer a variety of exclusive blends, a unique line of Wellness Herbal Teas, Children's Teas, Dog Teas, and specialty tea and herbal products.\n\nThe hand-crafted Teahouse was given to the city of Boulder as a gift from it's sister city, Dushanbe, Tajikistan as a symbol of peace and global friendship.  Today The Boulder Dushanbe Teahouse is a full service teahouse and restaurant offering over 100 premium loose leaf teas from around the world. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.388Z",
    importedBy: "entity-db-cli",
  },
};
